import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { ReactComponent as ArrowTopIc } from 'assets/icons/arrow-top.svg';

import theme from 'styles/theme';

const shouldForwardProp = (prop: string) =>
  !['showTour', 'active', 'withTable'].includes(prop);

type Active = {
  active: boolean;
};

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: row;
`;

export const ContainerWrap = styled.div`
  position: relative;
`;

type ContentProps = {
  withTable?: boolean;
};

export const Content = styled('div', { shouldForwardProp })<ContentProps>`
  overflow-y: scroll;
  width: 100%;
`;

export const DrawerContainer = styled.div`
  background-color: #f5f5f5 !important;
  width: 100% !important;
  height: 100% !important;

  @media (min-width: 1101px) {
    display: inline;
    background-color: #f5f5f5 !important;
  }
`;

export const DrawerContent = styled.div`
  background-color: #f5f5f5;
`;

export const NavLogo = styled.div`
  padding: 0 35px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Logo = styled.img`
  width: 100%;
`;

export const MenuItemContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 25px;
`;

export const SocialContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  flex-direction: row;
  padding-bottom: 30px;

  a + a {
    margin-left: 12px;
  }
`;

export const SocialIcon = styled.a`
  color: #fff;
  text-decoration: none !important;
  font-size: 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  &:hover {
    filter: brightness(0.7);
  }

  transition: 0.5s color;

  svg {
    width: 27px;
    height: 27px;
    flex-shrink: 0;
  }
`;

export const NavContainer = styled(Container)`
  width: 100%;
  height: 100%;
`;

type NavProps = {
  showTour?: boolean;
};

export const Nav = styled('nav', { shouldForwardProp })<NavProps>`
  background: ${theme.colors.blue};
  height: 100vh;
  width: 100%;
  max-width: 250px;
  padding: 25px 0px 0px 0px;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-y: scroll;

  ::-webkit-scrollbar-track {
    background-color: #f1f9ff;
  }
  ::-webkit-scrollbar {
    width: 0;
    background: #f1f9ff;
  }
  ::-webkit-scrollbar-thumb {
    background: #f1f9ff;
  }

  .align-item-menu {
    color: #fff;
    margin-left: 22px;
    width: 24px;
  }

  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
    `}
`;

export const CompanyContainer = styled.div`
  display: flex;
  background: #fff;
  width: calc(100% - 32px);
  margin: 20px 15px 0px 17px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;

export const TopList = styled('div', { shouldForwardProp })<Active>`
  width: 44px;
  height: 44px;
  display: ${({ active }) => (active ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  background: ${theme.colors.blue};
  border-radius: 22px;

  position: absolute;
  bottom: 0;
  right: 0;
  margin-right: 50px;
  margin-bottom: 70px;

  &:hover {
    cursor: pointer;
  }

  @media (max-width: 930px) {
    display: none;
  }
`;

export const ArrowTopIcon = styled(ArrowTopIc)``;
